// @ts-nocheck
import React, {useState, useEffect, useContext, useRef} from 'react';
import Router, {useRouter} from 'next/router';
import Breadcrumbs from '@/components/breadcrumbs';
import Fetch from '@/utils/Fetch';
import ToastContext from '@/utils/toast-context';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import ConfirmAction from '@/components/modals/confirm-action';
import Storage from '@/utils/storage';
import constants from '@/utils/constants';
import CustomerForm from '@/components/customer/CustomerForm'
import {Box, Button, Flex, Loader, Space} from "@mantine/core";
import { createFileRoute } from '@tanstack/react-router'



function CreateCustomer() {

    const router = useRouter();

  const toast = useContext(ToastContext);
  const [submitting, setSubmitting] = useState(false);

  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());
  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, submitCustomer, true);

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  const [triggerFormSaveCounter, setTriggerFormSaveCounter] = useState(0)
  const changeRouteAfterSaveUrl = useRef<any>(null)


  async function submitCustomer(routeChangeUrl: any) {
    setSubmitting(true);
    setTriggerFormSaveCounter((p: any) => p + 1)

    if(routeChangeUrl) {
      changeRouteAfterSaveUrl.current = routeChangeUrl;
    } else {
      changeRouteAfterSaveUrl.current = null;
    }

  }

  const submitData = async (payload: any) => {
    setFormIsDirty(false);

    // Defensive sanitize for locations before API and routing
    if (Array.isArray(payload?.Locations) && payload.Locations.length > 0) {
      payload.Locations = payload.Locations.map((loc: any) => {
        const l = { ...loc };
        delete l.Country;
        delete l.Type;
        delete l.LocationName;
        return {
          ID: l.ID ?? undefined,
          RowVersion: l.RowVersion ?? undefined,
          Description: l.Description ?? '',
          AddressLine1: l.AddressLine1 ?? '',
          AddressLine2: l.AddressLine2 ?? '',
          AddressLine3: l.AddressLine3 ?? '',
          AddressLine4: l.AddressLine4 ?? '',
          AddressLine5: l.AddressLine5 ?? '',
          Latitude: l.Latitude ?? null,
          Longitude: l.Longitude ?? null,
          CountryID: l.CountryID ?? null,
          CountryDescription: l.CountryDescription ?? null,
          LocationType: typeof l.LocationType === 'number' ? l.LocationType : (Enums.LocationType[l.LocationType] ?? Enums.LocationType.Delivery),
          IsPrimary: !!l.IsPrimary,
          IsActive: l.IsActive !== false,
        };
      });
    }

    const response = await Fetch.post({
      url: '/Customer',
      params: { ...payload, IsActive: true },
      toastCtx: toast
    });

      if (response.ID) {

        Helper.mixpanelTrack(constants.mixPanelEvents.createCustomer, {
          "customerID": response.ID
        });

        toast.setToast!!!({
          message: 'Customer created successfully',
          show: true,
          type: 'success'
        });

        setTimeout(() => {
          if(changeRouteAfterSaveUrl.current !== null) {
            Helper.nextRouter(router.push, changeRouteAfterSaveUrl.current);
          } else {
            Helper.nextRouter(router.push, '/customer/[id]', '/customer/' + response.ID);
          }
        }, 100)
      }
      setSubmitting(false)
  }

  const cancel = () => {
    Helper.nextRouter(router.push, '/customer/list');
  };

  const onError = (allErrors: any) => {
    setSubmitting(false);
    toast.setToast!!!({
      message: 'There are errors on the page',
      show: true,
      type: 'error'
    });
    changeRouteAfterSaveUrl.current = null
  }

  return (
      <div className="manage-container">
        <div className="row">
          <div className="title">
            <Breadcrumbs currPage={{text: 'Create Customer', link: '/customer/create', type: 'create'}}/>
          </div>
        </div>
        <Box maw={1020} >
          <CustomerForm
              accessStatus={accessStatus}
              onErrors={onError}
              onSaveValues={(values: any) => submitData(values)}
              onDirtyStateChange={(dirty: any) => {
                !submitting && setFormIsDirty(dirty)
              }}
              triggerFormSaveCounter={triggerFormSaveCounter}
              showAddContactAndLocationForms
          />

          <Space h={30} />

          <Flex
              justify={'end'}
              align={'center'}
              gap={'sm'}
              direction={'row-reverse'}
          >
            <Button
                disabled={submitting}
                rightSection={submitting && <Loader variant={'oval'} size={18} color={'white'}/>}
                onClick={() => submitCustomer()}
            >
              Create
            </Button>
            <Button
                variant={'subtle'}
                color={'gray.9'}
                onClick={cancel}
            >
              Cancel
            </Button>
          </Flex>

          <Space h={40} />

        </Box>

        <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions}/>

      </div>
  );
}

export default CreateCustomer;

export const Route = createFileRoute('/_authenticated/customer/create')({ component: CreateCustomer })
